import React from 'react';
import logo from "../assets/images/tclogo.png";
import logoBlack from "../assets/images/tc_logo.png";
import ICBSLogo from "../assets/images/ICBS_LOGO.png";
import vuLogo from "../assets/images/vu-logo.png";
import {useDispatch, useSelector} from "react-redux";
import {setIsChatMode} from '../store/reducers/questionReducer';

interface IProps {
}

export const Header = (props: IProps) => {
    const profilePath = useSelector((state: any) => state.questionReducer.profilePath);
    const dispatch = useDispatch();
    let logoImg = logo; //test logoBlack
    if (profilePath === 'david' || profilePath === 'david-shrier') {
        logoImg = ICBSLogo;
    } else if (profilePath === 'will-knight') {
        logoImg = logoBlack;
    } else if (profilePath === 'sky') {
        logoImg = vuLogo;
    }
    const clickOnLogo = () => {
        const page = (window as any).page ? (window as any).page : 'profile';
        if (page === 'social') {
            dispatch(setIsChatMode(false));
        }
    }
    return (
        <div className="tc-chat-header" id='tc-chat-header'>
            <div className="tc-chat-header-logo" onClick={clickOnLogo}>
                <img src={logoImg} alt=""/>
                {(profilePath === 'david' || profilePath === 'sky') &&
                    <div className={"tc-chat-header-logo-touchcast"}>
                        <a href='https://touchcast.com' target='_blank'><img
                            src={profilePath === 'will-knight' ? logoBlack : logo} alt="Touchcast"/></a>
                    </div>
                }
            </div>
        </div>
    );
}
